import { set, get, del, keys, update } from 'idb-keyval';

export async function saveOfflineMap(id, bundle) {
  try {
    await set(id, bundle);
  } catch (err) {
    throw err;
  }
}

export async function getOfflineMap(id) {
  try {
    const result = await get(id);
    return result;
  } catch (err) {
    throw err;
  }
}

export async function deleteOfflineMap(id) {
  try {
    await del(id);
  } catch (err) {
    throw err;
  }
}

export async function listOfflineMapIds() {
  try {
    const result = await keys();
    return result;
  } catch (err) {
    throw err;
  }
}

export async function updateOfflineMap(id, updateFn) {
  try {
    const result = await update(id, updateFn);
    return result;
  } catch (err) {
    throw err;
  }
}

export async function getZonesForMap(mapId) {
  try {
    const mapData = await getOfflineMap(mapId);
    return (mapData && Array.isArray(mapData.zones)) ? mapData.zones : [];
  } catch (err) {
    throw err;
  }
}

export async function saveZone(mapId, zone) {
  try {
    return await updateOfflineMap(mapId, (mapData = {}) => {
      const zones = Array.isArray(mapData.zones) ? mapData.zones : [];
      const idx = zones.findIndex(z => z.id === zone.id);
      if (idx !== -1) zones[idx] = zone;
      else zones.push(zone);
      return { ...mapData, zones };
    });
  } catch (err) {
    throw err;
  }
}

export async function updateZone(mapId, zone) {
  try {
    return await updateOfflineMap(mapId, (mapData = {}) => {
      const zones = Array.isArray(mapData.zones) ? mapData.zones : [];
      const idx = zones.findIndex(z => z.id === zone.id);
      if (idx !== -1) {
        zones[idx] = zone;
      } else {
        zones.push(zone);
      }
      return { ...mapData, zones };
    });
  } catch (err) {
    throw err;
  }
}

export async function deleteZone(mapId, zoneId) {
  try {
    return await updateOfflineMap(mapId, (mapData = {}) => {
      const zones = Array.isArray(mapData.zones) ? mapData.zones.filter(z => z.id !== zoneId) : [];
      return { ...mapData, zones };
    });
  } catch (err) {
    throw err;
  }
}
